var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status)?_c('span',{staticClass:"sb-badge",class:`sb-badge--${_vm.tone}`,attrs:{"title":_vm.status.name}},[(_vm.status.icon)?_c('i',{class:[_vm.status.icon, 'sb-badge-icon']}):_vm._e(),_c('span',{staticClass:"sb-badge-label"},[_vm._v(_vm._s(_vm.status.name))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }